<template>
  <tr class="ce-competitorProduct">
    <td class="ce-competitorProduct-name">
      <a :href="product.link">
        {{ product.name }}
      </a>
    </td>
    <td class="ce-competitorProduct-competitor">
      <a
        v-if="competitor"
        :href="competitor.link">
        {{ competitorValue }}
      </a>
      <template v-else>
        {{ competitorValue }}
      </template>
    </td>
    <td class="ce-caCompetitorApp-compareActionCell">
      <tooltip
        v-if="relationData && relationData.notes"
        :content="relationData.notes"
        trigger="click"
        :delay="0">
        <a
          href=""
          @click.prevent="">
          <fa-icon icon="exclamation-circle" />
        </a>
      </tooltip>
      <a
        href=""
        @click.prevent="compare">
        <fa-icon icon="exchange-alt" />
      </a>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['competitorApp', 'pigment']),
    ...mapState('generic', ['industries']),
    competitor() {
      if (!this.competitorApp) return null;

      return this.competitorApp.competitors
        .find((c) => c.id === this.product.competitor);
    },
    competitorValue() {
      return this.competitor ? this.competitor.name : this.product.competitor;
    },
    relationData() {
      const internalProductData = this.product.internalProducts.find((iP) => parseInt(iP.id) === parseInt(this.pigment.id));

      return internalProductData && internalProductData.relationData ? internalProductData.relationData : null;
    }
  },
  methods: {
    compare() {
      location.href = `/competitor-app/compare/${this.pigment.id}/${this.product.id}`;
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base.less';

.ce-competitorProduct {
  .ce-competitorProduct-name, .ce-competitorProduct-competitor {
    a {
      color: @color-text-base;
      text-decoration: underline;

      &:hover {
        color: @color-light;
      }
    }
  }

  .ce-caCompetitorApp-compareActionCell {
    display: flex;
    justify-content: flex-end;

    > * {
      padding: 0 @space-1;
    }

    a {
      color: @color-mono-60;

      &:hover {
        color: @color-light;
      }
    }
  }
}
</style>
